import React from 'react';
import Loader from '../Loader';

export const LoadingIndicator = () => (
  <Loader data-testid="LoadingIndicator" />
);

export default LoadingIndicator;
